export default __webpack_public_path__ + "static/media/icn_id.ab2dafa3.svg";